import { useMutation, useQuery } from "@tanstack/react-query";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import axiosBaseURL from "..";

export const useUsersList = (page: number = 1, size: number = 10) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["all users"],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/users/allUsers`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useMyUsersList = (page: number, size: number) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["users", user?.mfiId],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/users/myUsers`, {
        // const result = await axiosBaseURL.get(`/fe/user?orgId=${user?.mfiId}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useUserDetail = (id: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["user", id],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/fe/user/${id}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useGetUserByUserName = (username?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["user", username],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(
        `/users/username?username=${username}`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      return result;
    },
  });
};

export const useGetUserByEmail = (email?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["user", email],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/users/email?email=${email}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useGetUserByPhoneNumber = (phone?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["user", phone],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/users/phone?number=${phone}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useGetContactPersonByOrgId = (id?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["contact by orgId", id],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/users/contact/${id}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useGetUserStatusCount = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["user status"],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/users/mystatus`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useUserUpdateStatus = () => {
  const { refetch } = useUsersList();
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (data: { id: number; status: number }) => {
      const result = await axiosBaseURL.put(
        `/fe/user/${data.id}?status=${data.status}`,
        {},
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      refetch();
      return result;
    },
  });
};

export const useResetPassword = (id?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["password reset", id],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/users/reset/${id}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useLockUnlockUser = (id?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["lock / unlock user", id],
    staleTime: 120,
    enabled: false,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/users/lockUnlock/${id}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });
      return result;
    },
  });
};

// export const useUploadProfilePicture = () => {
//     return useMutation({
//         mutationFn: async (data: { id: string, file: File }) => {

//             const fileExt = data.file.name.split('.').pop();
//             const fileName = `${crypto.randomUUID()}.${fileExt}`;
//             const filePath = `${fileName}`;

//             const { error: uploadError, data: uploadData } = await supabase.storage.from('avatars').upload(filePath, data.file);
//             if (uploadError) {
//                 throw uploadError;
//             }

//             const { data: url } = supabase
//                 .storage
//                 .from('avatars')
//                 .getPublicUrl(uploadData.path, { download: ''});

//             const result = await supabase.from('profiles').update({ avatar_url: url.publicUrl }).eq('id', data.id);

//             return result;
//         },
//     });
// }
